import { type CountryCode } from 'libphonenumber-js';
import { COUNTRIES_DATA } from '@/config/countriesData';

export const getCountryCodeFromPrefix = (prefix: string): CountryCode => {
  const prefixToCountry: Record<string, CountryCode> = {
    '+1': 'US',
    '+44': 'GB',
    '+353': 'IE',
    '+27': 'ZA',
    '+61': 'AU',
  };
  return prefixToCountry[prefix] || 'US';
};

export const getPhonecodeByCountry = (countryValue: string): string => {
  const country = COUNTRIES_DATA.find((c) => c.value === countryValue);
  return country?.phonecode || '1';
};

export const formatPhoneForDisplay = ({
  value,
  phonecode = '1',
}: {
  value: string | null | undefined;
  phonecode?: string;
}): string => {
  if (!value) return '';
  const digits = value.replace(/\D/g, '');
  if (digits.length === 0) return '';
  const prefix = `+${phonecode}`;
  const tenDigits = digits.length > 10 ? digits.slice(digits.length - 10) : digits;
  if (tenDigits.length <= 3) return `${prefix} (${tenDigits})`;
  if (tenDigits.length <= 6) return `${prefix} (${tenDigits.slice(0, 3)}) ${tenDigits.slice(3)}`;
  return `${prefix} (${tenDigits.slice(0, 3)}) ${tenDigits.slice(3, 6)}-${tenDigits.slice(6)}`;
};

export const parseToE164 = (value: string | null | undefined, phonecode: string | undefined = '1'): string => {
  if (!value) return '';
  const digits = value.replace(/\D/g, '');
  if (digits.length === 0) return '';
  if (digits.startsWith(phonecode) && digits.length > 10) {
    return `+${digits}`;
  }
  return `+${phonecode}${digits}`;
};
